var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Col, Row } from "react-bootstrap";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import EdModal from "@frameworks/web/components/generic/edModal";
import GenericTable from "../../../../../../shared-library/components/GenericTable";
import UpiPopup from "./UpiPopup/UpiPopup";
import di from "../../di/serviceLocator";
import EditUpiPopup from "./UpiPopup/EditUpiPopup";
import { useSelector } from "react-redux";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
var UpiDetails = function () {
    var _a = __read(React.useState(false), 2), UpiDetailsPopup = _a[0], setUpiDetailsPopup = _a[1];
    var _b = __read(React.useState(false), 2), EditUpiDetailsPopup = _b[0], setEditUpiDetailsPopup = _b[1];
    var _c = __read(React.useState(false), 2), updateData = _c[0], setUpdateData = _c[1];
    var _d = __read(React.useState(), 2), editUpi = _d[0], setEditUpi = _d[1];
    var _e = __read(React.useState(), 2), upiDetailsDataState = _e[0], setUpiDetailsDataState = _e[1];
    var _f = __read(React.useState(false), 2), getDetailsUPIAPICall = _f[0], setGetDetailsUPIAPICall = _f[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var RelationColumn = [
        {
            columnName: "UPI ID",
            key: "UPI",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
        {
            columnName: "Source",
            key: "Source",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
        {
            columnName: "",
            key: "UPI",
            tdCustomFunction: function (key) {
                return (React.createElement("div", { className: "upibtn-block" },
                    React.createElement("i", { className: "edel-icon-edit-icon-large" }),
                    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Edit", onClick: function () {
                            setEditUpiDetailsPopup(true);
                            upiDetailsDataState === null || upiDetailsDataState === void 0 ? void 0 : upiDetailsDataState.map(function (upi) {
                                if (upi.UPI === key) {
                                    setEditUpi(upi);
                                }
                            });
                        } })));
            },
        },
    ];
    var selectedAccount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var getUPIDetailsData = function (data) {
        di.clients
            .getUPIDetailsData(data)
            .then(function (data) {
            if (data) {
                setUpiDetailsDataState(data);
            }
        })
            .catch(function (error) {
            console.log("fetching UPI data failed", error);
        });
    };
    React.useEffect(function () {
        if ((selectedAccount &&
            (selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode) &&
            getDetailsUPIAPICall) ||
            (selectedAccount && (selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode))) {
            getUPIDetailsData({ acCode: selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode });
            setGetDetailsUPIAPICall(false);
            getUPIDetailsData({ acCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode });
        }
    }, [getDetailsUPIAPICall, selectedAccount, updateData]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "upi-details-block mx-0 px-0 section-padding" },
            React.createElement(Row, { className: "relationship-head-block mx-0 displayFlex px-0" },
                React.createElement(Col, { className: "DMSanBold_18_700 txt_blackOne1" }, "UPI Details"),
                React.createElement(Col, { className: "taRight" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Add UPI", onClick: function () { return setUpiDetailsPopup(true); } }))),
            React.createElement(GenericTable, { columns: RelationColumn, data: upiDetailsDataState, parentClassName: "salestableParentClass", tableClassName: "salestableclass", message: {
                    msg: "No Data Found",
                    show: upiDetailsDataState === null ||
                        upiDetailsDataState === undefined ||
                        (upiDetailsDataState === null || upiDetailsDataState === void 0 ? void 0 : upiDetailsDataState.length) === 0
                        ? true
                        : false,
                    icon: "",
                } })),
        React.createElement(EdModal, { show: UpiDetailsPopup, setShow: setUpiDetailsPopup, showFooter: false, children: React.createElement(UpiPopup, { setUpiDetailsPopup: setUpiDetailsPopup, setGetDetailsUPIAPICall: setGetDetailsUPIAPICall }), modalTitle: "add-contact sales-client commonmodal", title: "Add UPI Details" }),
        React.createElement(EdModal, { show: EditUpiDetailsPopup, setShow: setEditUpiDetailsPopup, showFooter: false, children: React.createElement(EditUpiPopup, { editUpi: editUpi, setEditUpiDetailsPopup: setEditUpiDetailsPopup, setUpdateData: setUpdateData, EditUpiDetailsPopup: EditUpiDetailsPopup }), modalTitle: "add-contact sales-client commonmodal", title: "Edit UPI Details" })));
};
export default UpiDetails;
